import {ACTION_BUTTON_Z_INDEX} from '@components/game-room/ActionButtons';

// eslint-disable-next-line arrow-body-style
const desktop = theme => {
  return {
    antForm: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    buttonsRow: {
      width: '40%',
      background: 'transparent',
    },
  };
};

const mobile = theme => {
  return {
    hidden: {
      display: 'none',
    },
    insuranceSlider: {
      position: 'relative',
      height: '18px',
      padding: 0,
      '& .ant-slider-handle': {
        background: 'transparent url(/images-mobile/game-room/my_icon_black.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '27px 27px',
        backgroundPosition: 'center',
        height: 27,
        width: 27,
        border: 'none',
        zIndex: ACTION_BUTTON_Z_INDEX.SLIDER_HANDLE,
        '&:after': {
          content: props => '""',
          display: 'block',
          borderStyle: 'solid',
          borderWidth: '0 5px 11px 5px',
          borderColor: 'transparent transparent #7B1D82 transparent',
          position: 'relative',
          top: '27px',
          left: '8px',
          width: '11px',
        },
        '&:focus': {
          borderColor: 'transparent',
          boxShadow: 'none',
          filter:
            'drop-shadow(0px 0px 2px #FFFFFF) drop-shadow(0px 0px 10px rgba(255, 255, 255, 0.5))',
        },
      },
      '&.ant-slider': {
        margin: 0,
        '&:hover .ant-slider-rail': {
          backgroundColor: '#733A15',
        },
      },
      '& .ant-slider-rail': {
        boxShadow:
          'inset -2px -2px 5px rgba(255, 255, 255, 0.1), inset 2px 2px 5px rgba(0, 0, 0, 0.5)',
        // override hover color changes
        backgroundColor: 'rgba(255, 255, 255, 0.25) !important',
        borderRadius: '5px',
        border: 'none',
        width: '100%',
        bottom: 0,
        height: '18px',
      },
      '& .ant-slider-track': {
        // override hover color changes
        background: '#7B1D82 !important',
        boxShadow:
          'inset 0px 0px 4px 2px rgba(255, 255, 255, 0.25), inset 2px 2px 5px rgba(255, 255, 255, 0.1), inset -2px -2px 5px rgba(0, 0, 0, 0.5);',
        borderRadius: '5px',
        height: '18px',
        width: '100%',
      },
      '& .ant-slider-step': {
        display: 'none',
      },
      '& .ant-slider-mark': {
        width: '100%',
        left: 0,
        zIndex: ACTION_BUTTON_Z_INDEX.SLIDER_MARK,
      },
    },
    closeIcon: {
      cursor: 'pointer',
    },
    buttonsRow: {
      background: 'transparent',
      marginTop: 15,
      padding: [10, 30, 20],
      zIndex: ACTION_BUTTON_Z_INDEX.BUTTONS,
      '& .ant-btn:hover': {
        background: '#222222',
      },
      '& .ant-btn[disabled]': {
        backgroundColor: '#3B3B3B',
        boxShadow: 'inset 3px 3px 6px #000000BA',
        color: '#B2B2B2',
      },
    },
    sliderColumn: {
      display: 'flex',
      alignItems: 'flex-end',
      textAlign: 'center',
      '& > div': {
        width: '100%',
      },
    },
    confirmColumn: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    insuranceInfoContainer: {
      position: 'absolute',
      right: '0',
      bottom: 66,
      width: 240,
      minHeight: 127,
      background: 'rgba(44, 44, 49, 0.75)',
      boxShadow: 'inset 0px 0px 5px rgba(255, 255, 255, 0.5)',
      backdropFilter: 'blur(5px)',
      borderRadius: 5,
      border: 'none',
      padding: '6px 12px',
      fontWeight: 600,
      zIndex: ACTION_BUTTON_Z_INDEX.INSURANCE_INFO,
      fontSize: '16px',
      transformOrigin: 'bottom right',
    },
    insuranceConfirmButton: {
      // padding: '0px 10px',
      display: 'flex',
      border: 'none',
      // columnGap: '3px',
      justifyContent: 'space-around',
      alignItems: 'center',
      // border: '2px solid #6E6DFE',
      height: '34px',
      width: '100%',
      color: 'white',
      boxShadow: '4px 4px 2px rgba(0, 0, 0, 0.271)',
      fontSize: '14px',
      borderRadius: '5px',
      background:
        'linear-gradient(180deg, #578857 0%, #005500 100%), linear-gradient(180deg, #505050 0%, #151515 100%, #151515 100%)',
      '&:active, &:focus, &:hover': {
        color: 'white',
        background:
          'linear-gradient(180deg, #578857 0%, #005500 100%), linear-gradient(180deg, #505050 0%, #151515 100%, #151515 100%) !important',
      },
    },
    insuraceForceButton: {
      extend: 'insuranceConfirmButton',
      fontSize: '12px',
    },
    investmentLabel: {
      color: '#d5d5d5',
      marginBottom: 5,
    },
    insuranceSelectionContainer: {
      textAlign: 'center',
      alignItems: 'end',
      whiteSpace: 'nowrap',
      marginTop: '5px',
      background: 'rgba(225,225,225,0.25)',
      borderRadius: '5px',
      padding: '6px',
      justifyContent: 'space-around',
    },
    insurancePanelFontWhite: {
      color: '#FFFFFF',
      fontSize: '12px',
    },
    insurancePanelEqual: {
      marginBottom: '1px',
      marginLeft: '10px',
    },
    insurancePanelTimes: {
      marginBottom: '1px',
      marginRight: '5px',
    },
    insuranceWinningRate: {
      color: '#bdebcb',
      fontSize: '12px',
    },
    numOfOutCards: {
      marginLeft: 5,
    },
    insurancePanelFontMagenta: {
      color: '#FAD610',
      fontSize: '12px',
    },
    insurancePanelFontBlue: {
      color: '#08EA00',
      fontSize: '12px',
    },
    insurancePanelDetails: {
      color: '#FFFFFF',
      fontSize: '12px',
      opacity: '0.75',
      fontWeight: 500,
    },
    insurancePanelCardsArea: {
      display: 'grid',
      rowGap: '4px',
      columnGap: '4px',
      gridTemplateColumns: 'repeat(6, 1fr)',
      minHeight: '66px',
      maxHeight: '66px',
      overflow: 'auto',
      whiteSpace: 'nowrap',
    },
    alignRight: {
      textAlign: 'right',
    },
    minusButton: {
      marginTop: '-18px',
      transform: 'skew(20deg)',
      fontWeight: 600,
      color: 'white',
      background: '#7268EA',
      border: 'none',
      height: 27,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
